import JiraIcon from './customIcons/Jira'
import SubprocessIcon from './customIcons/Subprocess'
import TaskIcon from './customIcons/TaskIcon'
import ChangeShapeIcon from './customIcons/ChangeShapeIcon'
import DecisionIcon from './customIcons/DecisionIcon'
import ConnectionIcon from './customIcons/ConnectionIcon'
import OrganisationIcon from './customIcons/OrganisationIcon'
import ProjectIcon from './customIcons/ProjectIcon'
import SubworkflowIcon from './customIcons/SubworkflowIcon'
import WorkflowIcon from './customIcons/WorkflowIcon'
import McpIcon from './customIcons/McpIcon'
import { CARD_COLORS, EVENT_COLORS } from '@/shared/constants/colorPalette'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import { aliases, mdi as mdiSvg } from 'vuetify/iconsets/mdi-svg'
import { camelize, h } from 'vue'
import * as mdiPaths from './icons/mdi'
import materialSymbols from './icons/materialSymbols'

const customSvgNameTocomponent = {
  JiraIcon,
  SubprocessIcon,
  TaskIcon,
  ChangeShapeIcon,
  DecisionIcon,
  ConnectionIcon,
  OrganisationIcon,
  ProjectIcon,
  SubworkflowIcon,
  WorkflowIcon,
  McpIcon
}

const customSvgs = {
  component: (props) => h(customSvgNameTocomponent[props.icon])
}

const buildPaletteColors = (colors, variant) => {
  const result = {}
  for (const c of colors) {
    result[c.name] = c[variant]
  }
  return result
}

const paletteLight = {
  ...buildPaletteColors(CARD_COLORS, 'light'),
  ...buildPaletteColors(EVENT_COLORS, 'light')
}

const paletteDark = {
  ...buildPaletteColors(CARD_COLORS, 'dark'),
  ...buildPaletteColors(EVENT_COLORS, 'dark')
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: localStorage.getItem('qlerify-theme-resolved') || 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#F1F2F2',
          surface: '#FCFCFC',
          primary: '#022A44',
          secondary: '#229AD6',
          accent: '#C5539F',
          info: '#229AD6',
          error: '#FF5252',
          ...paletteLight
        }
      },
      dark: {
        dark: true,
        colors: {
          background: '#121518',
          surface: '#1E2228',
          primary: '#4DA8E8',
          secondary: '#5BC0F5',
          accent: '#D87FC5',
          info: '#5BC0F5',
          error: '#FF7777',
          ...paletteDark
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi: {
        // The old icon-font classes stay on the element because tests and components select icons by them.
        component: (props) => h(mdiSvg.component, { ...props, icon: mdiPaths[camelize(props.icon)], class: ['mdi', props.icon] })
      },
      mds: {
        component: (props) => {
          const iconName = props.icon.replaceAll('-', '_')

          // The label keeps the accessible name icon-only buttons got from the old ligature text.
          return (
            <span class="material-symbols-outlined" data-icon={iconName}>
              <svg class="v-icon__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" role="img" aria-label={iconName}>
                <path d={materialSymbols[iconName]} />
              </svg>
            </span>
          )
        }
      },
      custom: customSvgs
    }
  }
})
